import StateMachineImported from '@/states/GameStateMachine'
import SignalsImported from '@/signals/GameSignals'
import UIManagerImported from '@/managers/ui/InterfaceManager'
import AdapterImported from '../Relax/platforms/adapters/AdapterForJets'
import IntegrationManagerImported from "../Relax/platforms/IntegrationManager";

const GameStateMachine = StateMachineImported
const Signals = SignalsImported
const UIManager = UIManagerImported
const Adapter = AdapterImported
const IntegrationManager = IntegrationManagerImported

export {GameStateMachine, Signals, UIManager, Adapter, IntegrationManager}
